var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-banner-alert",class:{
    'wl-banner-alert--hurricane': _vm.isHurricane
  }},[_c('div',{staticClass:"wl-banner-alert__container"},[_c('div',{staticClass:"wl-banner-alert__icon"}),_vm._v(" "),_c('tz-markdown',{staticClass:"wl-banner-alert__copy",attrs:{"content":_vm.copy}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }